var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSquareFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.25C18.1904 1.25 18.75 1.80964 18.75 2.5V17.5C18.75 18.1904 18.1904 18.75 17.5 18.75H2.5C1.80964 18.75 1.25 18.1904 1.25 17.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H17.5ZM2.5 0C1.11929 0 0 1.11929 0 2.5V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5V2.5C20 1.11929 18.8807 0 17.5 0H2.5Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.375C7.5 14.0298 7.77982 13.75 8.125 13.75H11.875C12.2202 13.75 12.5 14.0298 12.5 14.375C12.5 14.7202 12.2202 15 11.875 15H8.125C7.77982 15 7.5 14.7202 7.5 14.375Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.625C5 10.2798 5.27982 10 5.625 10H14.375C14.7202 10 15 10.2798 15 10.625C15 10.9702 14.7202 11.25 14.375 11.25H5.625C5.27982 11.25 5 10.9702 5 10.625Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.875C2.5 6.52982 2.77982 6.25 3.125 6.25H16.875C17.2202 6.25 17.5 6.52982 17.5 6.875C17.5 7.22018 17.2202 7.5 16.875 7.5H3.125C2.77982 7.5 2.5 7.22018 2.5 6.875Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSquareFilter);
export default __webpack_public_path__ + "static/media/ico-square-filter.e59d05728433411bcdca60c951c51d19.svg";
export { ForwardRef as ReactComponent };